'use client';

import { Box, Text, VStack } from '@medsimples/design-system/src/chakra';
import { Button } from '@medsimples/design-system/src/components';
import NextLink from 'next/link';
import { useDesignTokens } from '../../providers/design_tokens_provider';

export default function WelcomePage() {
  const tokens = useDesignTokens();
  return (
    <>
      <Box marginBottom={20}>
        <VStack spacing='3rem'>
          <Text textAlign='center' fontSize='xl'>
            Olá! Caso ainda não esteja cadastrado, vamos cadastrar seu e-mail e
            celular
          </Text>
          <Text textAlign='center' fontSize='md' color={tokens.text.gray.color}>
            Se deseja acessar um cadastro existente, basta clicar em "Entrar" e
            escolher onde deseja receber o código de verificação
          </Text>
        </VStack>
      </Box>

      <Box w='100%'>
        <Button
          data-testid='signup-button'
          colorScheme={tokens.button.primary.scheme}
          marginBottom={5}
          href='/signup'
          as={NextLink}
        >
          Novo Cadastro
        </Button>
        <Button
          data-testid='login-button'
          href='/login_method'
          as={NextLink}
          colorScheme={tokens.button.primary.scheme}
        >
          Entrar
        </Button>
      </Box>
    </>
  );
}
